import type * as React from 'react'

import { styled } from 'styled-components'

import { Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

const StyledLink = styled.a<{ $disabled?: boolean }>`
  ${Typography.Body3}
  cursor: ${(o) => (o.$disabled ? 'default' : 'pointer')};
  color: ${designColors.primary.brightBlue};
  pointer-events: ${(o) => (o.$disabled ? 'none' : 'auto')};

  &:hover {
    text-decoration: underline;
  }
`

export const ActionLink = ({
  children,
  disabled,
  href,
  onClick,
}: {
  children: React.ReactNode
  disabled?: boolean
  href?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}) => (
  <StyledLink
    onClick={onClick}
    href={href}
    target="_blank"
    $disabled={disabled}
  >
    {children}
  </StyledLink>
)
